import { FormControlList } from './../../../modules/shared/constants/formcontrol-list.constants';
export const WORKBOOK_DYNAMIC_CHARTS = [
    {
        name: 'Bar Chart', code: 'barChart', fields: [
            {
                name: 'xaxis',
                label: 'X-Axis Field',
                description:'Select the field(s) to be displayed on the X-axis of the chart (Only text fields are selectable).',
                type: 'dropdown',
                selectedColumns: null,
                showOperation: false,
                fieldTypes: [FormControlList.AutoNumber, FormControlList.UserLookup, FormControlList.Email,
                FormControlList.DropDownList, FormControlList.RadioButton,
                FormControlList.Phone, FormControlList.InputBox, FormControlList.Date,
                FormControlList.DatePicker]
            },
            {
                name: 'yaxis',
                label: 'Y-Axis Fields',
                description:'Select the field(s) to be displayed on the Y-axis of the chart (Only numeric fields are selectable).',
                type: 'multiselect',
                selectedColumns: null,
                showOperation: true,
                fieldTypes: [FormControlList.Number, FormControlList.Decimal, FormControlList.Currency,
                FormControlList.Percentage, FormControlList.Rating]
            }
        ]
    },
    {
        name: 'Line Chart', code: 'lineChart', fields: [
            {
                name: 'xaxis',
                label: 'X-Axis Field',
                type: 'dropdown',
                description:'Select the field(s) to be displayed on the X-axis of the chart (Only text fields are selectable).',
                selectedColumns: null,
                showOperation: false,
                fieldTypes: [FormControlList.AutoNumber, FormControlList.UserLookup, FormControlList.Email,
                FormControlList.DropDownList, FormControlList.RadioButton,
                FormControlList.Phone, FormControlList.InputBox, FormControlList.Date,
                FormControlList.DatePicker]
            },
            {
                name: 'yaxis',
                label: 'Y-Axis Fields',
                type: 'multiselect',
                description:'Select the field(s) to be displayed on the Y-axis of the chart (Only numeric fields are selectable).',
                selectedColumns: null,
                showOperation: true,
                fieldTypes: [FormControlList.Number, FormControlList.Decimal, FormControlList.Currency,
                FormControlList.Percentage, FormControlList.Rating]
            }
        ]
    },
    {
        name: 'Pie Chart', code: 'pieChart', fields: [
            {
                name: 'xaxis',
                label: 'X-Axis Field',
                type: 'dropdown',
                description:'Select the field(s) to be displayed on the X-axis of the chart (Only text fields are selectable).',
                selectedColumns: null,
                showOperation: false,
                fieldTypes: [FormControlList.AutoNumber, FormControlList.UserLookup, FormControlList.Email,
                FormControlList.DropDownList, FormControlList.RadioButton,
                FormControlList.Phone, FormControlList.InputBox, FormControlList.Date,
                FormControlList.DatePicker]
            },
            {
                name: 'yaxis',
                label: 'Y-Axis Field',
                type: 'dropdown',
                description:'Select the field(s) to be displayed on the Y-axis of the chart (Only numeric fields are selectable).',
                selectedColumns: null,
                showOperation: true,
                fieldTypes: [FormControlList.Number, FormControlList.Decimal, FormControlList.Currency,
                FormControlList.Percentage, FormControlList.Rating]
            }
        ]
    },
    {
        name: 'Gantt Chart', code: 'ganttChart', fields: [
            {
                name: 'namefield',
                label: 'Y-Axis Fields',
                type: 'multiselect',
                description:'Select the field(s) to be displayed on the Y-axis of the chart (Only text fields are selectable).',
                selectedColumns: null,
                showOperation: false,
                fieldTypes: [FormControlList.AutoNumber, FormControlList.UserLookup, FormControlList.Email,
                FormControlList.DropDownList, FormControlList.RadioButton,
                FormControlList.Phone, FormControlList.InputBox, FormControlList.Date,
                FormControlList.DatePicker]
            },
            {
                name: 'startdate',
                label: 'Start Date Field',
                type: 'dropdown',
                description:'Select the field(s) to be displayed on the start date of the chart (Only date fields are selectable).',
                selectedColumns: null,
                showOperation: false,
                fieldTypes: [FormControlList.Date,FormControlList.DatePicker,FormControlList.DateTimePicker]
            },
            {
                name: 'enddate',
                label: 'End Date Field',
                type: 'dropdown',
                description:'Select the field(s) to be displayed on the end date of the chart (Only date fields are selectable).',
                selectedColumns: null,
                showOperation: false,
                fieldTypes: [FormControlList.Date,FormControlList.DatePicker,FormControlList.DateTimePicker]
            }
        ]
    }
];
